import { appConfig } from '../../../../../../../../../config/customization';

const iconSize = 25;

export default {
  activeRowContent: {
    backgroundColor: appConfig.colors.activeRowColor,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '0px 4%',
    height: 80,
    width: '100%',
    boxShadow: 'inset -2px -73px 46px -87px rgba(0,0,0,1)'
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 20px 15px 5px'
  },
  withoutPadding: {
    padding: 0
  },
  element: {
    paddingLeft: 5
  },
  icon: {
    height: iconSize,
    width: iconSize
  },
  deleteAccount: {
    marginBottom: 20
  },
  checkedBackground: {
    backgroundColor: appConfig.colors.checkedBackground,
    width: '20px',
    height: '20px',
    borderRadius: '100px',
    margin: '2px 0px 2px 3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkedOk: {
    strokeWidth: '2',
    stroke: appConfig.colors.checkedOk,
    fill: 'none',
    margin: '0px 0.5px 0px 0px'
  }
};
